<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref, watch} from "vue";
import {useSecurityStore} from "@/stores/Security";
import {storeToRefs} from "pinia";
import {useControlIssueStore} from "@/views/Notification/stores/ControlIssue";
import axios from "axios";

export default {
    name: "WIssueAutocomplete",
    props: {
        value: Array,
        module: {
            type: String,
            required: true,
        },
        label: String,
        rules: Array,
        readonly: Boolean,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        
        const valeurs = ref([]);
        const valeur = ref(null);
        
        const controlIssueStore = useControlIssueStore();
        
        const securityStore = useSecurityStore();
        
        const {idIssue} = storeToRefs(securityStore);
        
        watch(() => idIssue.value, () => {
            if (idIssue.value) {
                valeur.value = idIssue.value;
                emit('input', valeur ? [valeur.value] : []);
            } else {
                valeur.value = null;
                emit('input', null);
            }
        });
        
        function findAll() {
            loading.value = true;
            axios.get(`/controlPrograms/issue/${props.module}`).then(response => {
                controlIssueStore.setControlIssues(response.data);
            }).finally(() => {
                loading.value = false;
            })
        }
        
        function change() {
            emit('input', valeur.value ? [valeur.value] : [])
            idIssue.value = valeur.value;
        }
        
        watch(() => props.value, () => {
            if (props.value && props.value.length > 0)
                valeur.value = props.value[0];
        }, {immediate: true});
        
        onMounted(() => findAll());
        
        return {
            securityStore,
            valeurs,
            valeur,
            controlIssueStore,
            loading,
            inputColor,
            backgroundColor,
            change
        }
    },
}
</script>

<template>
    <div>
        <v-autocomplete
            v-if="securityStore.authorities.READ_NOTIFICATION_PARAM"
            v-model="valeur"
            :items="controlIssueStore.controlIssues"
            item-value="id"
            item-text="name"
            :label="label"
            outlined
            dense
            clearable
            :loading="loading"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
            :rules="rules"
            @change="change"
            @click:clear="$emit('input', [])"
        ></v-autocomplete>
        
        <input type="hidden"/>
    </div>
</template>

<style scoped>

</style>